import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "checked", "disabled", "required"]
const _hoisted_3 = { class: "ui-checkbox__checkmark" }
const _hoisted_4 = {
  key: 0,
  class: "ui-checkbox__text"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-checkbox__helper"
}
const _hoisted_6 = {
  key: 0,
  class: "ui-checkbox__error"
}
const _hoisted_7 = {
  key: 1,
  class: "ui-checkbox__helper-text"
}

import { computed, ref } from "vue";
import { Icon } from "@iconify/vue";
import type { Size } from "./types";

interface Props {
  modelValue?: boolean;
  label?: string;
  size?: Size;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  helperText?: string;
  id?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    modelValue: { type: Boolean },
    label: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: {},
    helperText: {},
    id: {}
  },
  emits: ["update:modelValue", "blur", "focus", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isFocused = ref(false);
const checkboxId = computed(
  () => props.id || `checkbox-${Math.random().toString(36).substr(2, 9)}`
);

const wrapperClasses = computed(() => {
  const classes = ["ui-checkbox"];
  classes.push(`ui-checkbox--${props.size}`);
  if (props.disabled) classes.push("ui-checkbox--disabled");
  if (props.error) classes.push("ui-checkbox--error");
  return classes;
});

const checkboxClasses = computed(() => {
  const classes = ["ui-checkbox__input"];
  if (isFocused.value) classes.push("ui-checkbox__input--focused");
  return classes;
});

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.checked;
  emit("update:modelValue", value);
  emit("change", value);
};

const handleBlur = (event: FocusEvent) => {
  isFocused.value = false;
  emit("blur", event);
};

const handleFocus = (event: FocusEvent) => {
  isFocused.value = true;
  emit("focus", event);
};

const handleLabelClick = (event: MouseEvent) => {
  if (props.disabled) {
    event.preventDefault();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(wrapperClasses.value)
  }, [
    _createElementVNode("label", {
      for: checkboxId.value,
      class: "ui-checkbox__label",
      onClick: handleLabelClick
    }, [
      _createElementVNode("input", {
        id: checkboxId.value,
        type: "checkbox",
        checked: __props.modelValue,
        disabled: __props.disabled,
        required: __props.required,
        class: _normalizeClass(checkboxClasses.value),
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus
      }, null, 42, _hoisted_2),
      _createElementVNode("span", _hoisted_3, [
        (__props.modelValue)
          ? (_openBlock(), _createBlock(_unref(Icon), {
              key: 0,
              icon: "mdi:check",
              class: "ui-checkbox__icon"
            }))
          : _createCommentVNode("", true)
      ]),
      (__props.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    (__props.error || __props.helperText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (__props.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.error), 1))
            : (__props.helperText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.helperText), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})